import React from 'react'
import styled from 'styled-components'

import { Image } from '@ui/blocks/Image'
import { runtimeConfig } from '@app/common/config'
import facebookIcon from '@ui/assets/images/learning-studio/social-icons/fb.svg'
import twitterIcon from '@ui/assets/images/learning-studio/social-icons/twitter.svg'

const ShareTweetLink = 'https://twitter.com/intent/tweet'
const ShareFacebookLink = 'https://www.facebook.com/sharer/sharer.php'

export const SocialIconsWrapper = styled.div`
  display: flex;
  flex-flow: column;
`

export const SocialIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4.8rem;
  height: 4.8rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.global.colors.ecru};

  &:first-child {
    margin-bottom: 2rem;
  }
`

interface SocialIconsProps {
  articleSlug: string
}

const SocialIcons = ({ articleSlug }: SocialIconsProps) => {
  const { SPROUT_BASE_URL } = runtimeConfig

  return (
    <SocialIconsWrapper>
      <a
        rel="noreferrer nofollow noopener"
        target="_blank"
        href={`${ShareFacebookLink}?u=${SPROUT_BASE_URL}/${articleSlug}`}>
        <SocialIcon>
          <Image src={facebookIcon} alt="Facebook logo" />
        </SocialIcon>
      </a>
      <a
        rel="noreferrer nofollow noopener"
        target="_blank"
        href={`${ShareTweetLink}?url=https://www.elemy.com/${articleSlug}`}>
        <SocialIcon>
          <Image src={twitterIcon} alt="Twitter logo" />
        </SocialIcon>
      </a>
    </SocialIconsWrapper>
  )
}

export default React.memo(SocialIcons)
